import jsPDF from 'jspdf';

const W = 210;
const M = 16;
const FOOT = 286;

function clean(v) {
  return String(v || '').replace(/[–—]/g, '-').replace(/[“”]/g, '"').replace(/[‘’]/g, "'");
}

function header(doc, meta) {
  doc.setFillColor(9, 30, 55);
  doc.rect(0, 0, W, 29, 'F');
  doc.setFillColor(0, 117, 190);
  doc.roundedRect(M, 7, 15, 15, 2, 2, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('ST', M + 7.5, 16.5, { align: 'center' });
  doc.setFontSize(13);
  doc.text('SALAR TECHNOLOGIES LLC', M + 20, 12);
  doc.setFontSize(7.2);
  doc.text('ENGINEERING THE FUTURE - AMERICAN GRIT. ADVANCED SYSTEMS.', M + 20, 18);
  doc.setFontSize(8);
  doc.text('INTERACTIVE DEMO REPORT', W - M, 12, { align: 'right' });
  doc.setFont('helvetica', 'normal');
  doc.text(`P${meta.index} | ${clean(meta.title).slice(0, 42)}`, W - M, 18, { align: 'right' });
}

function footer(doc) {
  doc.setDrawColor(130, 180, 220);
  doc.line(M, FOOT, W - M, FOOT);
  doc.setTextColor(25, 55, 85);
  doc.setFontSize(7);
  doc.text('Conceptual demonstration - illustrative synthetic data. Full capability under license - contact@salartechnologies.com', M, FOOT + 5);
  doc.setDrawColor(0, 117, 190);
  doc.rect(W - M - 14, FOOT - 15, 14, 14);
  doc.text('QR', W - M - 7, FOOT - 7, { align: 'center' });
}

function lines(doc, text, x, y, width, size = 8.5, bold = false) {
  doc.setFont('helvetica', bold ? 'bold' : 'normal');
  doc.setFontSize(size);
  const arr = doc.splitTextToSize(clean(text), width);
  doc.text(arr, x, y);
  return y + arr.length * (size * 0.43) + 4;
}

function card(doc, x, y, w, h, title, body, rgb = [239, 246, 255]) {
  doc.setFillColor(...rgb);
  doc.setDrawColor(0, 117, 190);
  doc.roundedRect(x, y, w, h, 2, 2, 'FD');
  doc.setTextColor(9, 30, 55);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8.5);
  doc.text(clean(title), x + 4, y + 7);
  doc.setTextColor(30, 50, 72);
  lines(doc, body, x + 4, y + 14, w - 8, 7.2);
}

function bar(doc, y, label, val) {
  doc.setTextColor(30, 50, 72);
  doc.setFontSize(7.5);
  doc.text(label, M, y + 4);
  doc.setFillColor(226, 232, 240);
  doc.rect(M + 50, y, 100, 5, 'F');
  doc.setFillColor(val >= 80 ? 20 : 245, val >= 80 ? 184 : 158, val >= 80 ? 166 : 11);
  doc.rect(M + 50, y, Math.max(6, val), 5, 'F');
  doc.setFont('helvetica', 'bold');
  doc.text(`${val}%`, M + 154, y + 4);
}

function values(i) {
  const base = [82, 78, 88, 81, 80, 85, 83, 79, 86][i - 1] || 80;
  return [base, Math.min(95, base + 6), Math.max(65, base - 8), Math.min(94, base + 3)];
}

export function generateDemoReportPdf(meta) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  header(doc, meta);
  footer(doc);
  let y = 42;
  doc.setTextColor(9, 30, 55);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.text(`P${meta.index}. ${clean(meta.title)}`, M, y);
  y += 8;
  y = lines(doc, `What this demo shows: ${meta.demoMeaning}`, M, y, W - 2 * M, 9, true);
  card(doc, M, y, 55, 32, 'INPUT', meta.requirement, [239, 246, 255]);
  card(doc, M + 61, y, 55, 32, 'SALAR ENGINE', 'Mock public demo engine. It displays the visible effect only; no private method logic is in this PDF or browser demo.', [236, 254, 255]);
  card(doc, M + 122, y, 56, 32, 'OUTPUT', meta.solution, [240, 253, 244]);
  doc.setFontSize(14);
  doc.setTextColor(0, 117, 190);
  doc.text('>', M + 57, y + 18);
  doc.text('>', M + 118, y + 18);
  y += 42;
  doc.setTextColor(9, 30, 55);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text('Pass / fail demo scorecard', M, y);
  y += 8;
  const v = values(meta.index);
  bar(doc, y, 'Requirement clarity', v[0]);
  bar(doc, y + 10, 'Failure visibility', v[1]);
  bar(doc, y + 20, 'Action readiness', v[2]);
  bar(doc, y + 30, 'Buyer relevance', v[3]);
  y += 44;
  card(doc, M, y, 86, 34, 'BAD VERSION', meta.badCase, [255, 238, 238]);
  card(doc, M + 92, y, 86, 34, 'BEST VERSION', meta.goodCase, [232, 249, 244]);
  y += 44;
  y = lines(doc, `What just happened: the demo changed a visible input state and showed a synthetic output state for this use case. The purpose is explanation and licensing discussion, not disclosure of the full method.`, M, y, W - 2 * M, 9, true);
  y = lines(doc, `Relevance: ${meta.relevance}`, M, y, W - 2 * M, 8.5);
  y = lines(doc, `Achievement: ${meta.achievement}`, M, y, W - 2 * M, 8.5);
  doc.setTextColor(0, 117, 190);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('Full method available under license - contact@salartechnologies.com', M, 270);
  doc.save(`SALAR_P${meta.index}_${meta.slug}_DEMO_REPORT.pdf`);
}
